import {CustomFieldSection} from './CustomFieldSection';
import {t} from 'i18next';
import {IFieldModal} from './constant';
import {useMemo} from 'react';
import {Box, Divider, Typography} from '@mui/material';

interface IFieldCategoryListProps {
  fieldData?: IFieldModal;
}

const FieldCategoryList: React.FC<IFieldCategoryListProps> = ({fieldData}) => {
  const title = useMemo(() => {
    return fieldData?.fieldCategory === 'STR'
      ? t('fieldManagement.customField.strTable')
      : t('fieldManagement.customField.exports');
  }, [fieldData?.fieldCategory]);

  const renderItem = useMemo(() => {
    return (
      <Box className={'custom-tag-container-drawer'}>
        <Box className={'custom-field-drawer-body'} >
          <Box className={'tag-header tag-header-top-radius'} tabIndex={0}>
            <Typography className="body2" tabIndex={0}>
              {t('fieldManagement.customField.name')}
            </Typography>
          </Box>

          {fieldData?.tagValues && fieldData?.tagValues?.length > 0 && (
            <>
              <Box className="drag-list">
                {fieldData.tagValues.map((tag) => (
                  <>
                    <Box className="drag-item" tabIndex={0}>
                      <Box display="flex" alignItems="center" gap={1} tabIndex={0}>
                        {tag.tagValue}
                      </Box>
                    </Box>
                    <Divider />
                  </>
                ))}
              </Box>

              <Box className={'tag-header tag-header-bottom-radius'} tabIndex={0}>
                <Typography className={'body2'} tabIndex={0}>
                  {fieldData.tagValues.length}{' '}
                  {t(
                    fieldData?.fieldCategory === 'STR'
                      ? 'fieldManagement.customField.terms'
                      : 'fieldManagement.customField.exports'
                  )}
                </Typography>
              </Box>
            </>
          )}
        </Box>
      </Box>
    );
  }, [fieldData?.fieldCategory, fieldData?.tagValues]);

  return (fieldData?.tagValues?.length ?? 0) > 0 ? (
    <CustomFieldSection title={title}>{renderItem}</CustomFieldSection>
  ) : (
    <></>
  );
};

export {FieldCategoryList};
